import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AuthLogin from './Auth/AuthLogin';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, userRole, loading, hasAnyRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative overflow-hidden font-sans">
        {/* Arka Plan Dekoratif Elementler */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-600/20 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-cyan-500/10 rounded-full blur-[120px]"></div>
        
        <div className="relative z-10 text-center">
          {/* Modern Spinner */}
          <div className="relative mb-8 mx-auto w-20 h-20">
            <div className="absolute inset-0 border-4 border-white/20 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-transparent border-t-white rounded-full animate-spin"></div>
            <div className="absolute inset-2 border-4 border-white/10 rounded-full"></div>
            <div className="absolute inset-2 border-4 border-transparent border-r-cyan-300 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
          </div>
          
          {/* Modern Yazı */}
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-3 tracking-tight">
            <span className="bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent">
              Yükleniyor
            </span>
          </h1>
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-cyan-300 rounded-full animate-pulse"></div>
            <div className="w-2 h-2 bg-cyan-300 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-2 h-2 bg-cyan-300 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          </div>
          <p className="text-blue-200/70 text-sm md:text-base font-light">Pronuve Su Yönetimi</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AuthLogin />;
  }

  // Eğer allowedRoles belirtilmişse, kullanıcının rolünü kontrol et
  if (allowedRoles.length > 0 && !hasAnyRole(allowedRoles)) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '20px'
      }}>
        <h2 style={{ margin: 0 }}>Erişim Reddedildi</h2>
        <p style={{ margin: 0 }}>Bu sayfaya erişim yetkiniz bulunmamaktadır.</p>
        <p style={{ margin: 0 }}>Mevcut rolünüz: <strong>{userRole || 'Tanımsız'}</strong></p>
        <p style={{ margin: 0 }}>Gerekli roller: {allowedRoles.join(', ')}</p>
        <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>
          Lütfen Cognito'da kullanıcınızın doğru group'a eklendiğinden emin olun.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
